import React, { useEffect, useState } from "react";
import { getViewInfo } from "src/common/attrView";
import { seedSeparators } from "src/common/attrView/viewFormItems/Separator";
import { onError } from "src/common/onError";
import { makeLabels4Leaves } from "../../../makeLabels4Leaves";
import { MakeLabelParams } from "../../../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../../../utils/getAttrLabelTreeData";
import { SimpleText } from "../../SimpleText/SimpleText";

interface PropsAttrLinkedLabel {
  params: MakeLabelParams;
}

export const AttrLinkedLabel: React.FC<PropsAttrLinkedLabel> = ({ params }) => {
  const [label, setLabel] = useState<React.ReactNode>([]);
  useEffect(() => {
    try {
      const { attribute, attributeList, typesMap } = params;
      const attrTreeData = getAttrLabelTreeData(
        params.attribute,
        params.labelTreeData,
      );
      if (!attrTreeData) return;
      const linkedAttr = attrTreeData.children?.[0];
      if (!linkedAttr) return;
      const leavesLabels = makeLabels4Leaves(
        [linkedAttr],
        attributeList,
        typesMap,
        params.mode,
      );
      const viewInfo = getViewInfo(attribute.viewType);
      const finalLabels = seedSeparators(
        leavesLabels.map((e, i) => ({
          key: i,
          content: e,
        })),
        viewInfo?.appearance?.view?.separator,
      );
      setLabel(<SimpleText values={finalLabels} viewInfo={viewInfo} />);
    } catch (error) {
      onError(error);
    }
  }, []);

  return label;
};
